import { Stack } from "@mui/material";
import { Calendar as BigCalendar, Views, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { useEffect, useState } from "react";
import index from "../../../api/auth/reservations";
import { red } from "@mui/material/colors";
import ReservationSlot from "../calendar/ReservationSlot";

const locales = {
	"en-US": require("date-fns")
};

const localizer = dateFnsLocalizer({
	format,
	parse,
	startOfWeek,
	getDay,
	locales
});

export default function Calendar({ views, defaultView, height }) {
  const [reservations, setReservations] = useState();

  useEffect(() => {
    index({status: ['confirmed', 'paid']}, (response) => {
      setReservations(response);
    });
  }, []);

  const eventPropGetter = (reservation) => {
    console.log(reservation?.reservation_items[0]?.item?.item_category?.tag_color);
    var backgroundColor =  reservation?.reservation_items[0]?.item?.item_category?.tag_color;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: 'black',
        border: '0px',
        display: 'block',
    };
    return {
        style: style
    };
  };

  return (
    <Stack
      sx={{
        '.rbc-row-segment': {
          '.rbc-event-allday': {
            '&:not(.rbc-event-continues-prior)': {
              borderLeft: `5px solid #00b4d2 !important`,
            },
            '&:not(.rbc-event-continues-after)': {
              borderRight: `5px solid ${red.A400} !important`
            }
          }
        }
      }}
    >
      <BigCalendar
        views={views || [Views.MONTH, Views.WEEK, Views.DAY]}
        defaultView={defaultView || Views.WEEK}
        show
        localizer={localizer}
        events={reservations}
        startAccessor={(reservation) => new Date(reservation.start_at)}
        endAccessor={(reservation) => new Date(reservation.end_at)}
        style={{ height: height || '65vh' }}
        titleAccessor={(reservation) => <ReservationSlot key={reservation.id} reservation={reservation} />}
        eventPropGetter={(eventPropGetter)}
      />
    </Stack>
  );
}